var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.99995 3.69978C9.99995 3.69978 6.69995 2.49978 6.69995 4.99978V6.89978H9.89995L9.59995 9.99978H6.59995V20.4998H2.59995V9.89978H0.699951V6.79978H2.59995V4.99978V3.59978C2.59995 3.59978 2.59995 1.09978 5.79995 0.399782C8.09995 -0.100218 10.3 0.599782 10.3 0.599782L9.99995 3.69978Z"}));
}

Facebook.defaultProps = {"width":"11","height":"21","viewBox":"0 0 11 21","fill":"currentColor"};

module.exports = Facebook;

Facebook.default = Facebook;
